import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
export function Bonuses() {
  return <section className="py-20 bg-[#fffbeb]" data-id="element-35">
      <div className="container px-4 mx-auto max-w-4xl" data-id="element-36">
        <div className="text-center mb-12" data-id="element-37">
          <div className="inline-flex items-center justify-center gap-2 px-4 py-1.5 mb-4 text-sm font-black tracking-wider text-white uppercase bg-[#ef4444] rounded-full animate-pulse" data-id="element-38">
            <Sparkles className="w-4 h-4" data-id="element-39" />
            Oferta Especial
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-[#0c3b42] uppercase tracking-tight" data-id="element-40">
            BONUS PROFESIONALES GRATIS POR EL DÍA DE HOY
          </h2>
        </div>

        <div className="space-y-8" data-id="element-41">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative bg-white p-8 md:p-10 rounded-2xl border-2 border-[#f59e0b] shadow-lg overflow-hidden" data-id="element-42">
            <div className="absolute top-0 right-0 bg-[#f59e0b] text-white font-black px-6 py-1.5 rounded-bl-xl text-sm uppercase tracking-wider" data-id="element-43">
              ¡Gratis Hoy!
            </div>
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-44">
              <div className="w-16 h-16 bg-[#fef3c7] rounded-2xl flex items-center justify-center flex-shrink-0 border border-[#fde68a]" data-id="element-45">
                <Gift className="w-8 h-8 text-[#d97706]" data-id="element-46" />
              </div>
              <div data-id="element-47">
                <div className="text-[#d97706] font-black text-sm uppercase tracking-wider mb-1" data-id="element-48">
                  BONUS #1
                </div>
                <h3 className="text-2xl font-black text-[#0c3b42] mb-3" data-id="element-49">
                  Guía de psicoeducación para el deportista
                </h3>
                <p className="text-slate-600 font-medium mb-3" data-id="element-50">
                  Material explicativo listo para entregar al deportista.
                </p>
                <p className="text-slate-600 leading-relaxed" data-id="element-51">
                  Este bonus te ayuda a explicarle de forma clara qué es el
                  trabajo mental, para qué sirve y cómo puede potenciar su
                  rendimiento sin prometer resultados ni caer en frases
                  motivacionales vacías.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative bg-white p-8 md:p-10 rounded-2xl border-2 border-[#f59e0b] shadow-lg overflow-hidden" data-id="element-52">
            <div className="absolute top-0 right-0 bg-[#f59e0b] text-white font-black px-6 py-1.5 rounded-bl-xl text-sm uppercase tracking-wider" data-id="element-53">
              ¡Gratis Hoy!
            </div>
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-54">
              <div className="w-16 h-16 bg-[#fef3c7] rounded-2xl flex items-center justify-center flex-shrink-0 border border-[#fde68a]" data-id="element-55">
                <Gift className="w-8 h-8 text-[#d97706]" data-id="element-56" />
              </div>
              <div data-id="element-57">
                <div className="text-[#d97706] font-black text-sm uppercase tracking-wider mb-1" data-id="element-58">
                  BONUS #2
                </div>
                <h3 className="text-2xl font-black text-[#0c3b42] mb-3" data-id="element-59">
                  Banco de Técnicas de Regulación Emocional Adaptadas
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-60">
                  Técnicas específicas organizadas por tipo de discapacidad,
                  emoción predominante y momento del proceso deportivo. Listas
                  para usar en sesión.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}